module.exports = __webpack_public_path__ + "static/media/dialogues-dark.9f6af481.png";